/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigNoContentResponse,
  BboBranchConfigUnauthorizedResponse,
  GetBranchCommonConfigResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get branch common config
 * @summary Get branch common config
 */
export const getBranchCommonConfig = (signal?: AbortSignal) => {
  return customInstance<GetBranchCommonConfigResponseResponse | BboBranchConfigNoContentResponse>({
    url: `/BboBranchConfigService/v2/branch/common/config`,
    method: 'get',
    signal,
  });
};

export const getGetBranchCommonConfigQueryKey = () => {
  return [`/BboBranchConfigService/v2/branch/common/config`] as const;
};

export const getGetBranchCommonConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranchCommonConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBranchCommonConfig>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchCommonConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranchCommonConfig>>> = ({ signal }) =>
    getBranchCommonConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranchCommonConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBranchCommonConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranchCommonConfig>>
>;
export type GetBranchCommonConfigQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get branch common config
 */
export const useGetBranchCommonConfig = <
  TData = Awaited<ReturnType<typeof getBranchCommonConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getBranchCommonConfig>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBranchCommonConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
